import {
  Navigate,
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
  redirect,
} from "react-router-dom";
import "./App.css";

import Root from "./components/layout/Root";
import JobList from "./features/jobs/JobList";
import ClientList from "./features/clients/ClientList";
import DeviceList from "./features/devices/DeviceList";
import NewJob from "./features/jobs/NewJob";
import EditJob from "./features/jobs/EditJob";
import Worksheet from "./pdf/views/WorkSheet";
import { CalLabel } from "./pdf/views/CalLabel";
import Settings from "./features/settings/Settings";
import NewClient from "./features/clients/NewCileint";
import EditClient from "./features/clients/EditClient";
import NewDevice from "./features/devices/NewDevice";
import EditDevice from "./features/devices/EditDevice";
import Login from "./features/auth/Login";
import server from "./server/lib/fetchRequests";
import EtalonList from "./features/etalons/EtalonList";
import NewEtalon from "./features/etalons/NewEtalon";
import EditEtalon from "./features/etalons/EditEtalon";
import Certificate from "./features/calibration/Certificate";
import CertificatePdf from "./pdf/views/Certificate";
import { CalLabel_ENG } from "./pdf/views/CalLabel_ENG";
import CertificatePdf_ENG from "./pdf/views/Certificate_ENG";

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/login" element={<Login />}></Route>
      <Route
        path="/"
        element={<Root />}
        loader={async () => {
          const response = await new server().get("/auth/check");
          if (!response.data.authorized) {
            return redirect("/login");
          }
          return null;
        }}>
        <Route path="/" element={<Navigate to="/jobs" replace />} />
        <Route path="jobs" element={<JobList />}></Route>
        <Route path="jobs/new" element={<NewJob />}></Route>
        <Route path="jobs/:id" element={<EditJob />}></Route>
        <Route path="jobs/:id/calibration" element={<Certificate />}></Route>
        <Route path="clients" element={<ClientList />}></Route>
        <Route path="clients/new" element={<NewClient />}></Route>
        <Route path="clients/:id" element={<EditClient />}></Route>
        <Route path="devices" element={<DeviceList />}></Route>
        <Route path="devices/new" element={<NewDevice />}></Route>
        <Route path="devices/:id" element={<EditDevice />}></Route>
        <Route path="etalons" element={<EtalonList />}></Route>
        <Route path="etalons/new" element={<NewEtalon />}></Route>
        <Route path="etalons/:id" element={<EditEtalon />}></Route>
        <Route path="settings" element={<Settings />}></Route>
      </Route>
      <Route path="/jobs/:id/pdf" element={<Worksheet />}></Route>
      <Route path="/jobs/:id/calibration/label" element={<CalLabel />}></Route>
      <Route path="/jobs/:id/calibration/label-eng" element={<CalLabel_ENG />}></Route>
      <Route path="/jobs/:id/calibration/pdf" element={<CertificatePdf />}></Route>
      <Route path="/jobs/:id/calibration/pdf-eng" element={<CertificatePdf_ENG />}></Route>
    </>
  )
);

export default function App() {
  return <RouterProvider router={router} />;
}
